import { css } from 'styled-components';
import colors from './colors';

export const brandGradient = css`
  linear-gradient(180deg, #00d16d 0%, #00b85f 100%);
`;

export const brandTransparent = css`
  background: ${colors.brandTransparent};
`;

export const actionPrimary = css`
  background-color: ${colors.action};

  &:hover {
    background-color: ${colors.darkAction};
  }

  &:active {
    background-color: ${colors.darkerAction};
  }
`;

export const actionTransparent = css`
  background: rgba(0, 163, 255, 0.1);

  &:hover {
    background: rgba(0, 163, 255, 0.2);
  }

  &:active {
    background: rgba(0, 163, 255, 0.3);
  }
`;

export const whiteTransparent = css`
  background: ${colors.whiteTransparent};
  backdrop-filter: blur(100px);
`;

const backgrounds = {
  brandGradient,
  brandTransparent,
  actionPrimary,
  actionTransparent,
  whiteTransparent,
};

export default backgrounds;
